export default __webpack_public_path__ + "static/media/apple.1a115544.svg";